module.exports = __webpack_public_path__ + "07bca9e4f5b2c3e30518c28837be0f04.png";


//////////////////
// WEBPACK FOOTER
// ./assets/images/perks/houses/skaters-shack-main.png
// module id = 595
// module chunks = 0